export const allCurrencies = [
	{ name: 'Euro', value: 'eur' },
	{ name: 'United States Dollar', value: 'usd' },
	{ name: 'British Pound Sterling', value: 'gbp' },
	{ name: 'Swiss Franc', value: 'chf' },
	{ name: 'Renminbi', value: 'cny' },
	{ name: '--------', value: '' },
	{ name: 'United Arab Emirates Dirham', value: 'aed' },
	{ name: 'Afghan Afghani', value: 'afn' },
	{ name: 'Albanian Lek', value: 'all' },
	{ name: 'Armenian Dram', value: 'amd' },
	{ name: 'Netherlands Antillean Guilder', value: 'ang' },
	{ name: 'Angolan Kwanza', value: 'aoa' },
	{ name: 'Argentine Peso', value: 'ars' },
	{ name: 'Australian Dollar', value: 'aud' },
	{ name: 'Aruban Florin', value: 'awg' },
	{ name: 'Azerbaijani Manat', value: 'azn' },
	{ name: 'Bosnia-Herzegovina Convertible Mark', value: 'bam' },
	{ name: 'Barbadian Dollar', value: 'bbd' },
	{ name: 'Bangladeshi Taka', value: 'bdt' },
	{ name: 'Bulgarian Lev', value: 'bgn' },
	{ name: 'Bahraini Dinar', value: 'bhd' },
	{ name: 'Burundian Franc', value: 'bif' },
	{ name: 'Bermudan Dollar', value: 'bmd' },
	{ name: 'Brunei Dollar', value: 'bnd' },
	{ name: 'Bolivian Boliviano', value: 'bob' },
	{ name: 'Brazilian Real', value: 'brl' },
	{ name: 'Bahamian Dollar', value: 'bsd' },
	{ name: 'Bitcoin', value: 'btc' },
	{ name: 'Bhutanese Ngultrum', value: 'btn' },
	{ name: 'Botswanan Pula', value: 'bwp' },
	{ name: 'Belarusian Ruble', value: 'byn' },
	{ name: 'Belize Dollar', value: 'bzd' },
	{ name: 'Canadian Dollar', value: 'cad' },
	{ name: 'Congolese Franc', value: 'cdf' },
	{ name: 'Chilean Unit of Account (UF)', value: 'clf' },
	{ name: 'Chilean Peso', value: 'clp' },
	{ name: 'Chinese Yuan (Offshore)', value: 'cnh' },
	{ name: 'Colombian Peso', value: 'cop' },
	{ name: 'Costa Rican Colón', value: 'crc' },
	{ name: 'Cuban Convertible Peso', value: 'cuc' },
	{ name: 'Cuban Peso', value: 'cup' },
	{ name: 'Cape Verdean Escudo', value: 'cve' },
	{ name: 'Czech Republic Koruna', value: 'czk' },
	{ name: 'Djiboutian Franc', value: 'djf' },
	{ name: 'Danish Krone', value: 'dkk' },
	{ name: 'Dominican Peso', value: 'dop' },
	{ name: 'Algerian Dinar', value: 'dzd' },
	{ name: 'Egyptian Pound', value: 'egp' },
	{ name: 'Eritrean Nakfa', value: 'ern' },
	{ name: 'Ethiopian Birr', value: 'etb' },
	{ name: 'Fijian Dollar', value: 'fjd' },
	{ name: 'Falkland Islands Pound', value: 'fkp' },
	{ name: 'Georgian Lari', value: 'gel' },
	{ name: 'Guernsey Pound', value: 'ggp' },
	{ name: 'Ghanaian Cedi', value: 'ghs' },
	{ name: 'Gibraltar Pound', value: 'gip' },
	{ name: 'Gambian Dalasi', value: 'gmd' },
	{ name: 'Guinean Franc', value: 'gnf' },
	{ name: 'Guatemalan Quetzal', value: 'gtq' },
	{ name: 'Guyanaese Dollar', value: 'gyd' },
	{ name: 'Hong Kong Dollar', value: 'hkd' },
	{ name: 'Honduran Lempira', value: 'hnl' },
	{ name: 'Croatian Kuna', value: 'hrk' },
	{ name: 'Haitian Gourde', value: 'htg' },
	{ name: 'Hungarian Forint', value: 'huf' },
	{ name: 'Indonesian Rupiah', value: 'idr' },
	{ name: 'Israeli New Sheqel', value: 'ils' },
	{ name: 'Manx Pound', value: 'imp' },
	{ name: 'Indian Rupee', value: 'inr' },
	{ name: 'Iraqi Dinar', value: 'iqd' },
	{ name: 'Iranian Rial', value: 'irr' },
	{ name: 'Icelandic Króna', value: 'isk' },
	{ name: 'Jersey Pound', value: 'jep' },
	{ name: 'Jamaican Dollar', value: 'jmd' },
	{ name: 'Jordanian Dinar', value: 'jod' },
	{ name: 'Japanese Yen', value: 'jpy' },
	{ name: 'Kenyan Shilling', value: 'kes' },
	{ name: 'Kyrgystani Som', value: 'kgs' },
	{ name: 'Cambodian Riel', value: 'khr' },
	{ name: 'Comorian Franc', value: 'kmf' },
	{ name: 'North Korean Won', value: 'kpw' },
	{ name: 'South Korean Won', value: 'krw' },
	{ name: 'Kuwaiti Dinar', value: 'kwd' },
	{ name: 'Cayman Islands Dollar', value: 'kyd' },
	{ name: 'Kazakhstani Tenge', value: 'kzt' },
	{ name: 'Laotian Kip', value: 'lak' },
	{ name: 'Lebanese Pound', value: 'lbp' },
	{ name: 'Sri Lankan Rupee', value: 'lkr' },
	{ name: 'Liberian Dollar', value: 'lrd' },
	{ name: 'Lesotho Loti', value: 'lsl' },
	{ name: 'Libyan Dinar', value: 'lyd' },
	{ name: 'Moroccan Dirham', value: 'mad' },
	{ name: 'Moldovan Leu', value: 'mdl' },
	{ name: 'Malagasy Ariary', value: 'mga' },
	{ name: 'Macedonian Denar', value: 'mkd' },
	{ name: 'Myanma Kyat', value: 'mmk' },
	{ name: 'Mongolian Tugrik', value: 'mnt' },
	{ name: 'Macanese Pataca', value: 'mop' },
	{ name: 'Mauritanian Ouguiya (Pre-2018)', value: 'mro' },
	{ name: 'Mauritanian Ouguiya', value: 'mru' },
	{ name: 'Mauritian Rupee', value: 'mur' },
	{ name: 'Maldivian Rufiyaa', value: 'mvr' },
	{ name: 'Malawian Kwacha', value: 'mwk' },
	{ name: 'Mexican Peso', value: 'mxn' },
	{ name: 'Malaysian Ringgit', value: 'myr' },
	{ name: 'Mozambican Metical', value: 'mzn' },
	{ name: 'Namibian Dollar', value: 'nad' },
	{ name: 'Nigerian Naira', value: 'ngn' },
	{ name: 'Nicaraguan Córdoba', value: 'nio' },
	{ name: 'Norwegian Krone', value: 'nok' },
	{ name: 'Nepalese Rupee', value: 'npr' },
	{ name: 'New Zealand Dollar', value: 'nzd' },
	{ name: 'Omani Rial', value: 'omr' },
	{ name: 'Panamanian Balboa', value: 'pab' },
	{ name: 'Peruvian Nuevo Sol', value: 'pen' },
	{ name: 'Papua New Guinean Kina', value: 'pgk' },
	{ name: 'Philippine Peso', value: 'php' },
	{ name: 'Pakistani Rupee', value: 'pkr' },
	{ name: 'Polish Zloty', value: 'pln' },
	{ name: 'Paraguayan Guarani', value: 'pyg' },
	{ name: 'Qatari Rial', value: 'qar' },
	{ name: 'Romanian Leu', value: 'ron' },
	{ name: 'Serbian Dinar', value: 'rsd' },
	{ name: 'Russian Ruble', value: 'rub' },
	{ name: 'Rwandan Franc', value: 'rwf' },
	{ name: 'Saudi Riyal', value: 'sar' },
	{ name: 'Solomon Islands Dollar', value: 'sbd' },
	{ name: 'Seychellois Rupee', value: 'scr' },
	{ name: 'Sudanese Pound', value: 'sdg' },
	{ name: 'Swedish Krona', value: 'sek' },
	{ name: 'Singapore Dollar', value: 'sgd' },
	{ name: 'Saint Helena Pound', value: 'shp' },
	{ name: 'Sierra Leonean Leone', value: 'sll' },
	{ name: 'Somali Shilling', value: 'sos' },
	{ name: 'Surinamese Dollar', value: 'srd' },
	{ name: 'South Sudanese Pound', value: 'ssp' },
	{ name: 'São Tomé and Príncipe Dobra (Pre-2018)', value: 'std' },
	{ name: 'São Tomé and Príncipe Dobra', value: 'stn' },
	{ name: 'Salvadoran Colón', value: 'svc' },
	{ name: 'Syrian Pound', value: 'syp' },
	{ name: 'Swazi Lilangeni', value: 'szl' },
	{ name: 'Thai Baht', value: 'thb' },
	{ name: 'Tajikistani Somoni', value: 'tjs' },
	{ name: 'Turkmenistani Manat', value: 'tmt' },
	{ name: 'Tunisian Dinar', value: 'tnd' },
	{ name: "Tongan Pa'anga", value: 'top' },
	{ name: 'Turkish Lira', value: 'try' },
	{ name: 'Trinidad and Tobago Dollar', value: 'ttd' },
	{ name: 'New Taiwan Dollar', value: 'twd' },
	{ name: 'Tanzanian Shilling', value: 'tzs' },
	{ name: 'Ukrainian Hryvnia', value: 'uah' },
	{ name: 'Ugandan Shilling', value: 'ugx' },
	{ name: 'Uruguayan Peso', value: 'uyu' },
	{ name: 'Uzbekistan Som', value: 'uzs' },
	{ name: 'Venezuelan Bolívar Fuerte', value: 'vef' },
	{ name: 'Vietnamese Dong', value: 'vnd' },
	{ name: 'Vanuatu Vatu', value: 'vuv' },
	{ name: 'Samoan Tala', value: 'wst' },
	{ name: 'CFA Franc BEAC', value: 'xaf' },
	{ name: 'Silver Ounce', value: 'xag' },
	{ name: 'Gold Ounce', value: 'xau' },
	{ name: 'East Caribbean Dollar', value: 'xcd' },
	{ name: 'Special Drawing Rights', value: 'xdr' },
	{ name: 'CFA Franc BCEAO', value: 'xof' },
	{ name: 'Palladium Ounce', value: 'xpd' },
	{ name: 'CFP Franc', value: 'xpf' },
	{ name: 'Platinum Ounce', value: 'xpt' },
	{ name: 'Yemeni Rial', value: 'yer' },
	{ name: 'South African Rand', value: 'zar' },
	{ name: 'Zambian Kwacha', value: 'zmw' },
	{ name: 'Zimbabwean Dollar', value: 'zwl' },
];
